module.exports = __webpack_public_path__ + "static/media/data_science.434d2b01.svg";